import React from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import DatePicker from '@amzn/meridian/date-picker';
import Text from '@amzn/meridian/text';
import moment from 'moment';
import { setSelectedFilterOptions } from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';

const FILTER_DATE_FORMAT = 'MM/DD/YYYY';
const DATE_PICKER_FORMAT = 'YYYY-MM-DD';

const formatDatePickerValue = (date: string) =>
  date === '' ? '' : moment(date, FILTER_DATE_FORMAT, true).format(DATE_PICKER_FORMAT);
const formatFilterValue = (date: string) =>
  date === '' ? '' : moment(date, DATE_PICKER_FORMAT, true).format(FILTER_DATE_FORMAT);

const StartAndEndDateInput = () => {
  const dispatch = useDispatch();
  const { selectedFilterOptions } = useAppSelector((state) => state.placementOverviewPage);

  return (
    <Column spacing="400">
      <Column spacing="100">
        <Text>Placement Start Date</Text>
        <DatePicker
          value={formatDatePickerValue(selectedFilterOptions.placementStartDate)}
          onChange={(newValue) => {
            dispatch(
              setSelectedFilterOptions({
                ...selectedFilterOptions,
                placementStartDate: formatFilterValue(newValue),
              }),
            );
          }}
          placeholder="MM/DD/YYYY"
        />
      </Column>
      <Column spacing="100">
        <Text>Placement End Date</Text>
        <DatePicker
          value={formatDatePickerValue(selectedFilterOptions.placementEndDate)}
          onChange={(newValue) => {
            dispatch(
              setSelectedFilterOptions({
                ...selectedFilterOptions,
                placementEndDate: formatFilterValue(newValue),
              }),
            );
          }}
          placeholder="MM/DD/YYYY"
        />
      </Column>
    </Column>
  );
};

export default StartAndEndDateInput;
